import { GalleryImage } from "components/shared/Gallery/typings";

export const getFullScreenImages = (images: GalleryImage[]): GalleryImage[] => {
  return images.map((galleryItemImage: GalleryImage) => ({
    ...galleryItemImage,
    src: galleryItemImage.originalMediaUrl || galleryItemImage.src
  }));
};
